export default "__VITE_ASSET__0451a374__"